import { createContext } from 'react';
import { UCFStore } from 'ucf-lib';

export const StoreContext = createContext<UCFStore>({} as UCFStore);
export const StoreProvider = StoreContext.Provider;
